// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3a7im","containerItemsCenter":"Skeleton_containerItemsCenter__32HOW"};